<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Donor Acceptability Criteria
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="acceptHepBCore"
              disabled
              label="Accept Hep B Core Ab+ Donor"
            />
          </div>
          <!-- <div class="col-3">
          <div class="fieldName">
            Accept Hep B Core Ab+ Donor
          </div>
          <input
            v-model="acceptHepBCore"
            class="inputDisplay"
            disabled
          >
        </div>  -->

          <div class="col-2">
            <ADSTextInput
              v-model="preferredDonorType"
              disabled
              label="Preferred Donor Type"
            />
          </div>

          <!-- <div class="col-3">
          <div class="fieldName">
            Preferred Donor Type
          </div>
          <input
            v-model="preferredDonorType"
            class="inputDisplayPreferredDonorType"
            disabled
          >
        </div> -->

          <div class="col-2">
            <ADSTextInput
              v-model="acceptA2A2BDonor"
              disabled
              label="Accept A2 or A2B Donor"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="acceptABOIncompatibleDonor"
              disabled
              label="Accept ABO Incompatible Donor"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="acceptHCVAbPlusDonor"
              disabled
              label="Accept HCV Ab+ Donor"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="acceptHCVNATPlusDonor"
              disabled
              label="Accept HCV NAT+ Donor"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="acceptExtendedCriteriaDonor"
              disabled
              label="Accept Extended Criteria Donor"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="comments"
              disabled
              label="Comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DonorAcceptabilitySectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      acceptHepBCore: this.getAcceptHepBCore( this.patientBundle ),
      preferredDonorType: this.getPreferredDonorType( this.patientBundle ),
      acceptA2A2BDonor: this.getAcceptA2A2BDonor( this.patientBundle ),
      acceptABOIncompatibleDonor: this.getAcceptABOIncompatibleDonor( this.patientBundle ),
      acceptHCVAbPlusDonor: this.getAcceptHCVAbPlusDonor( this.patientBundle ),
      acceptHCVNATPlusDonor: this.getAcceptHCVNATPlusDonor( this.patientBundle ),
      acceptExtendedCriteriaDonor: this.getAcceptExtendedCriteriaDonor( this.patientBundle ),
      comments: this.getDonorAcceptanceComments( this.patientBundle )
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getAcceptHepBCore( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );
      if( observation && observation[ 0 ] ) {
        let acceptHepBCore = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#348' ) ) ;
        return _.get( acceptHepBCore[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      }
    },
    getPreferredDonorType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let preferredDonorType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#357' ) ) ;
      return _.get( preferredDonorType[ 0 ], 'resource.component[0].valueString' );
      }
    },
    getAcceptA2A2BDonor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let acceptA2A2BDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#345' ) ) ;
      return _.get( acceptA2A2BDonor[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      }
    },
    getAcceptABOIncompatibleDonor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let acceptABOIncompatibleDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#343' ) ) ;
      return _.get( acceptABOIncompatibleDonor[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      }
    },
    getAcceptHCVAbPlusDonor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let acceptHCVAbPlusDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#347' ) ) ;
      return _.get( acceptHCVAbPlusDonor[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      }
    },
    getAcceptHCVNATPlusDonor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let acceptHCVAbPlusDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#346' ) ) ;
      return _.get( acceptHCVAbPlusDonor[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      }
    },
    getAcceptExtendedCriteriaDonor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let acceptHCVAbPlusDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#349' ) ) ;
      return _.get( acceptHCVAbPlusDonor[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      }
    },
    getDonorAcceptanceComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' ) );  
      if( observation && observation[ 0 ] ) {
      let acceptHCVAbPlusDonor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.category[0].coding[0].code' ) === 'smartdata' && _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16532' ) ) ;
      return _.get( acceptHCVAbPlusDonor[ 0 ], 'resource.component[0].valueString' );
      }
    },
    
  },
};
</script>

<style scoped>

/* .card {
  height: 350px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 350px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayPreferredDonorType {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
